<script lang="ts">
    import HeaderView from "./component/header/HeaderView.svelte";
    import {AuthStore} from "./store/AuthStore";
    import FooterView from "./component/footer/FooterView.svelte";
    import {onMount} from "svelte";
    import FullScreenLoadingView from "./component/common/Loading/FullScreenLoadingView.svelte";
    import CornerMessageView from "./component/common/Message/CornerMessageView.svelte";
    import ConfirmMessageView from "./component/common/Message/ConfirmMessageView.svelte";
    import {HttpRequestUtil} from "./lib/Common/Http/HttpRequestUtil";
    import {SetupHttpRequestUtil} from "./SetupHttpRequestUtil";
    import {FontUtil} from "./lib/Common/Font/FontUtil";
    import AppEnvironmentView from "./component/common/Environment/AppEnvironmentView.svelte";

    import SlackInquiryChannelLinkView from "./component/common/Slack/SlackInquiryChannelLinkView.svelte";
    import MouseEnterTipsView from "./component/common/Information/MouseEnterTipsView.svelte";
    import Home from "./page/Home/Home.svelte";
    import TemporaryCsvDiff from "./page/Space/TemporaryCsv/TemporaryCsvDiff.svelte";
    import {AuthViewUtil} from "./page/Auth/AuthViewUtil";
    import Router from "svelte-spa-router";
    import NotFound from "./page/NotFound.svelte";
    import SpaceSetting from "./page/Space/Setting/SpaceSetting.svelte";


    $: authStoreAuthStatus = AuthStore.authStatus;

    // ルーティング
    function createRoutes() {
        const authRoutes = {
            "/space/setting": SpaceSetting,


        };
        const routes = AuthViewUtil.createAuthWrapRoutes(authRoutes);
        routes["/"] = Home;
        routes["/temp_csv/diff/:diff_url_token"] = TemporaryCsvDiff;
        routes["*"] = NotFound;

        return routes;
    }

    onMount(() => {
        // HttpRequest の初期設定
        const httpRequestUtilSettings = SetupHttpRequestUtil.createHttpRequestUtilSettings();
        HttpRequestUtil.setSettings(httpRequestUtilSettings);

        // Font設定
        FontUtil.WebFont.load(FontUtil.WebFont.Url.NotoSansJP);

    });

    /**
     * ページ移動時の処理
     * @param event
     */
    function onRouteLoaded(event) {
        // console.log('routeLoaded', event);

        // ページ遷移時に一番上へ自動スクロール
        window.scrollTo(0, 0);
    }
</script>
<svelte:head>

    <style lang="scss" src="./css/ValueTable.scss"/>
    <style lang="scss" src="./css/ColorTable.scss"/>
    <style lang="scss" src="./css/common/StandardTag.scss"/>
    <style lang="scss" src="./css/common/StandardClass.scss"/>
    <style lang="scss" src="./css/common/StandardAnimation.scss"/>

</svelte:head>
<main>
    <HeaderView/>

    <div class="body">
        <Router routes={createRoutes()} on:routeLoaded={onRouteLoaded}/>

    </div>


    <FooterView/>

    <SlackInquiryChannelLinkView url="https://bnsi.slack.com/archives/C043TJ0RD62"/>

    <div id="portal-target"></div>

    <div class="search-dialog-area">


    </div>


    <MouseEnterTipsView/>

    <ConfirmMessageView/>
    <CornerMessageView/>
    <FullScreenLoadingView/>

    <AppEnvironmentView/>
</main>

<style lang="scss">

    main {
        margin: 0 auto;
        background: var(--background);

        min-height: 100vh;
        display: flex;
        flex-direction: column;
        color: var(--text-color);

        .body {
            flex-grow: 1;

        }


        font-family: Noto Sans JP, sans-serif;;


    }


</style>

<!--<style lang="scss" src="./css/ColorTable.scss"/>-->
